import { FloatingFormItem } from '@/components/_common';
import { BankAccount } from '@/core/domain/enterprise/BankAccounts/BankAccounts.types';
import { bankConfig } from '@/core/domain/financial/Boletos/Boletos.dictionary';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, AutoComplete, Input } from 'antd';

interface Props {
  bankAccount?: BankAccount;
}
export default function WalletFields({ bankAccount }: Props) {
  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  const bankMapFields = bankAccount ? bankConfig[bankAccount?.bank.code] : null;

  return (
    <>
      {!!bankMapFields?.fields.agreementWallet && (
        <Col span={24} md={12} lg={6} xxl={3}>
          <FloatingFormItem
            label="Carteira"
            name={['general', 'agreementWallet']}
            rules={
              !!bankMapFields?.fields.agreementWallet.required
                ? [
                    {
                      type: 'string',
                      max: bankMapFields?.fields.agreementWallet?.maxLength,
                      message: `Quantidade máxima: ${bankMapFields?.fields.agreementWallet?.maxLength}`,
                    },
                    defaultEmptyFieldError,
                  ]
                : [
                    {
                      type: 'string',
                      max: bankMapFields?.fields.agreementWallet?.maxLength,
                      message: `Quantidade máxima: ${bankMapFields?.fields.agreementWallet?.maxLength}`,
                    },
                    defaultEmptyFieldError,
                  ]
            }
          >
            <AutoComplete
              style={{ width: '100' }}
              options={bankMapFields?.fields.agreementWallet.options?.map(
                (value) => ({ value, label: value }),
              )}
            />
          </FloatingFormItem>
        </Col>
      )}

      <Col span={24} md={12} lg={6} xxl={3}>
        <FloatingFormItem
          label="Variação Carteira"
          name={['general', 'titleVariationWallet']}
        >
          <Input />
        </FloatingFormItem>
      </Col>
    </>
  );
}
